export const TreesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3161_18103)">
      <g clipPath="url(#clip1_3161_18103)">
        <path
          d="M24.9437 34.8639C23.3682 34.8639 22.0085 33.9093 21.4247 32.5569C20.8329 33.9093 19.4812 34.8639 17.9057 34.8639H16.818C14.7946 34.8639 13.139 33.3047 12.9951 31.3317H8.5963C6.8368 31.3317 5.25324 30.3691 4.44547 28.8099C3.64569 27.2586 3.77366 25.405 4.79737 23.9889L6.57287 21.5228C6.54088 21.4114 6.50889 21.308 6.4849 21.1966C6.19698 19.9397 6.4609 18.6032 7.20469 17.5292L9.45206 14.3152C9.15615 13.0981 9.35609 11.7695 10.0999 10.6637L13.4909 5.62001C14.3627 4.33124 15.8103 3.55957 17.3698 3.55957C18.9294 3.55957 20.385 4.33124 21.2487 5.62001L24.6318 10.6637C24.6798 10.7433 24.7278 10.8149 24.7758 10.8944C25.0157 10.8546 25.2556 10.8387 25.4956 10.8387C27.0311 10.8387 28.4547 11.5945 29.3105 12.8673L32.5256 17.6565C33.2454 18.7225 33.4533 20.0033 33.1894 21.1807L35.2768 24.1719C36.2525 25.5641 36.3725 27.37 35.5727 28.8815C34.7809 30.393 33.2214 31.3317 31.5099 31.3317H29.8703C29.7264 33.3047 28.0628 34.8639 26.0474 34.8639H24.9597H24.9437Z"
          fill="url(#paint0_linear_3161_18103)"
        />
        <path
          d="M17.92 32.1738H16.8735C16.4426 32.1738 16.0886 31.7718 16.0886 31.2824V27.0351C16.0886 26.9914 16.1194 26.9564 16.1578 26.9564H18.628C18.6665 26.9564 18.6973 26.9914 18.6973 27.0351V31.2824C18.6973 31.7718 18.3433 32.1738 17.9123 32.1738H17.92Z"
          fill="#084F1B"
        />
        <path
          d="M6.84808 26.0906L9.82301 21.7928C9.02916 21.33 8.69238 20.2142 9.27774 19.3464L12.5814 14.4453C11.9399 13.9329 11.6914 12.9576 12.2046 12.1642L15.5965 6.92421C16.246 5.91589 17.6893 5.91589 18.3389 6.92421L21.7308 12.1642C22.244 12.9576 22.0034 13.9329 21.3619 14.4453L24.6656 19.3464C25.251 20.2142 24.9142 21.33 24.1203 21.7928L27.0953 26.0906C27.8731 27.2146 27.0953 28.7767 25.7562 28.7767H8.1872C6.84808 28.7767 6.06224 27.2146 6.84808 26.0906Z"
          fill="url(#paint1_linear_3161_18103)"
        />
        <path
          d="M26.1798 32.1738H25.1333C24.7023 32.1738 24.3483 31.7718 24.3483 31.2824V27.0351C24.3483 26.9914 24.3791 26.9564 24.4176 26.9564H26.8878C26.9263 26.9564 26.957 26.9914 26.957 27.0351V31.2824C26.957 31.7718 26.603 32.1738 26.1721 32.1738H26.1798Z"
          fill="#084F1B"
        />
        <path
          d="M31.5132 28.6957H19.7927C18.5598 28.6957 17.8341 27.2507 18.5364 26.2035L21.5875 21.6413C20.9866 21.1623 20.7681 20.245 21.2519 19.5063L24.3888 14.6193C24.9897 13.6777 26.324 13.6777 26.9249 14.6193L30.0618 19.5063C30.5378 20.245 30.3193 21.1623 29.7262 21.6413L32.7695 26.2035C33.4718 27.2507 32.7461 28.6957 31.521 28.6957H31.5132Z"
          fill="url(#paint2_linear_3161_18103)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3161_18103"
        x1="20.001"
        y1="33.8855"
        x2="20.001"
        y2="4.84843"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E300" />
        <stop offset="0.509615" stopColor="#00E300" stopOpacity="0.945" />
        <stop offset="0.600962" stopColor="#17FC00" stopOpacity="0.89" />
        <stop offset="1" stopColor="#8CFC00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3161_18103"
        x1="16.9757"
        y1="28.3638"
        x2="16.9757"
        y2="3.56904"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007900" />
        <stop offset="1" stopColor="#00C800" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3161_18103"
        x1="25.6451"
        y1="30.1163"
        x2="25.6451"
        y2="8.91249"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#045111" />
        <stop offset="1" stopColor="#019B0C" />
      </linearGradient>
      <clipPath id="clip0_3161_18103">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_3161_18103">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
